import makeCrud from '@/store/site/localization/crud'
export default makeCrud('module_tracking_code')
